module.exports = __webpack_public_path__ + "img/20200513_160656.89045f9d.jpg";